module.exports = __webpack_public_path__ + "img/ablanca.9323ae94.png";